// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearShop = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 17',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.00659 7.97998V10.9733C2.00659 13.9666 3.20659 15.1666 6.19993 15.1666H9.79326C12.7866 15.1666 13.9866 13.9666 13.9866 10.9733V7.97998',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.99999 8.50016C9.21999 8.50016 10.12 7.50683 9.99999 6.28683L9.55999 1.8335H6.44666L5.99999 6.28683C5.87999 7.50683 6.77999 8.50016 7.99999 8.50016Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.2068 8.50016C13.5534 8.50016 14.5401 7.40683 14.4068 6.06683L14.2201 4.2335C13.9801 2.50016 13.3134 1.8335 11.5668 1.8335H9.53345L10.0001 6.50683C10.1134 7.60683 11.1068 8.50016 12.2068 8.50016Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.75992 8.50016C4.85992 8.50016 5.85325 7.60683 5.95992 6.50683L6.10659 5.0335L6.42659 1.8335H4.39326C2.64659 1.8335 1.97992 2.50016 1.73992 4.2335L1.55992 6.06683C1.42659 7.40683 2.41326 8.50016 3.75992 8.50016Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.99992 11.8335C6.88659 11.8335 6.33325 12.3868 6.33325 13.5002V15.1668H9.66659V13.5002C9.66659 12.3868 9.11325 11.8335 7.99992 11.8335Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearShop };
